import tenants from "../config/tenants.json";
import categoriesJSON from "../config/categories.json";

let environment: string | undefined = process.env.TROX_ENVIRONMENT;
if (environment === "local") {
  environment = "development";
}
if (!environment) {
  throw new Error("Environment should be defined");
}

const tenantsForEnv = tenants[environment as keyof typeof tenants].tenants;
const tenantValues = Object.values(tenantsForEnv).map(
  (tenantSettings) => tenantSettings.client_name,
);
const tenantKeys = tenantValues
  .filter((t) => t) // compact
  .filter((val, idx, arr) => arr.indexOf(val) === idx) // uniq
  .sort();

export const categoryClients = tenantKeys
  .concat(categoriesJSON.clients_without_tenants)
  .filter((val, idx, arr) => arr.indexOf(val) === idx)
  .sort();
export const categoryOwners = categoryClients
  .concat(categoriesJSON.permissions.additional_owners)
  .filter((val, idx, arr) => arr.indexOf(val) === idx)
  .sort();

const locals = Object.values(tenantsForEnv).map((t) => t.allowed_locales);
const localsKeys = locals
  .filter((t) => t)
  .flat()
  .sort();
const languages = localsKeys.map((locKey) => locKey.split("-")[0]);
export const categoryLanguages = languages
  .filter((val, idx, arr) => arr.indexOf(val) === idx)
  .sort();

const defaultPageAttributes = {
  categoryClients: ["multienum", { values: [...categoryClients] }],
  categoryLanguages: ["multienum", { values: [...categoryLanguages] }],
  categoryOwner: ["multienum", { values: [...categoryOwners] }],
  isJSSiteReady: "boolean",
  publishFrom: "date",
  publishUntil: "date",
  title: "string",
  showConfiguratorNav: "boolean",
  subtitle: "string",
} as const;

export default defaultPageAttributes;
